import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Toast } from '@common-web';
import { settlementsListingApi } from '@apis/seller-center/settlements.js';
import { getErrorString } from '@utils/utils';

const initialState = {
  settlements: [],
  pagination: null,
  statuses: [],
  loading: false,
};

export const fetchSettlementsListing = createAsyncThunk('settlements/listing', async (params = '') => {
  try {
    const settlements = await settlementsListingApi(params);
    return settlements;
  } catch (err) {
    Toast.error(getErrorString(err));
    return [];
  }
});

const SettlementsSlice = createSlice({
  name: 'settlements',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSettlementsListing.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchSettlementsListing.fulfilled, (state, action) => {
        state.settlements = action?.payload?.settlements;
        state.statuses = action?.payload?.statuses_and_dispositions ?? [];
        state.pagination = action?.payload?.pagination;
        state.loading = false;
      });
  },
});

export default SettlementsSlice.reducer;
